/*!
  super-loader.js  — SherlockHolmes.com
  Combines:
   - Ahrefs Analytics (async)
   - Google Tag (GA4) (async + init)
   - Booster-style prefetch on hover/touch (instant-navigation)

  Notes:
   • Idempotent: safe if included more than once
   • Non-blocking: uses async/defer pattern
   • No external dependencies
*/

(function () {
  if (window.__SL_LOADED__) return;  // idempotence
  window.__SL_LOADED__ = true;

  // ---------- tiny helpers ----------
  function addLink(rel, href, attrs) {
    try {
      var l = document.createElement('link');
      l.rel = rel; l.href = href;
      if (attrs) Object.entries(attrs).forEach(function([k,v]){ l.setAttribute(k, v); });
      document.head.appendChild(l);
    } catch(e){}
  }
  function loadScript(src, attrs) {
    try {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      if (attrs) Object.entries(attrs).forEach(function([k,v]){ s.setAttribute(k, v); });
      document.head.appendChild(s);
      return s;
    } catch(e){ return null; }
  }

  // ---------- performance hints (optional but nice) ----------
  addLink('preconnect', 'https://analytics.ahrefs.com', {crossorigin:''});
  addLink('preconnect', 'https://www.googletagmanager.com', {crossorigin:''});

  // ---------- Ahrefs Analytics ----------
  loadScript('https://analytics.ahrefs.com/analytics.js', {
    'data-key': 'BfJC5ONuasCS79AXB1mVqw'
  });

  // ---------- Google Tag (GA4) ----------
  // bootstrap dataLayer + config immediately so hits queue even before gtag.js returns
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag; // expose for other scripts if needed
  gtag('js', new Date());
  gtag('config', 'G-FJSJ1QZG40');

  loadScript('https://www.googletagmanager.com/gtag/js?id=G-FJSJ1QZG40');

  // ---------- Booster-style instant navigation (prefetch on hover/touch) ----------
  // (Based on the common instant-page approach; small + safe)
  try {
    var urlToPreload, mouseoverTimer, lastTouchTimestamp;
    var prefetcher = document.createElement('link');
    var isSupported = prefetcher.relList && prefetcher.relList.supports && prefetcher.relList.supports('prefetch');
    var isDataSaverEnabled = navigator.connection && navigator.connection.saveData;
    var allowQueryString = 'instantAllowQueryString' in document.body.dataset;
    var allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset;

    if (isSupported && !isDataSaverEnabled) {
      prefetcher.rel = 'prefetch';
      document.head.appendChild(prefetcher);

      var opt = { capture: true, passive: true };
      document.addEventListener('touchstart', onTouchStart, opt);
      document.addEventListener('mouseover', onMouseOver, opt);
    }

    function onTouchStart(e){
      lastTouchTimestamp = performance.now();
      var a = e.target.closest('a');
      if (isPreloadable(a)) {
        a.addEventListener('touchcancel', onTouchEndCancel, { passive: true });
        a.addEventListener('touchend', onTouchEndCancel, { passive: true });
        urlToPreload = a.href; preload(a.href);
      }
    }
    function onTouchEndCancel(){ urlToPreload = undefined; stopPreloading(); }

    function onMouseOver(e){
      if (performance.now() - lastTouchTimestamp < 1100) return;
      var a = e.target.closest('a');
      if (isPreloadable(a)) {
        a.addEventListener('mouseout', onMouseOut, { passive: true });
        urlToPreload = a.href;
        mouseoverTimer = setTimeout(function(){
          preload(a.href); mouseoverTimer = undefined;
        }, 65);
      }
    }
    function onMouseOut(e){
      if (e.relatedTarget && e.target.closest('a') == e.relatedTarget.closest('a')) return;
      if (mouseoverTimer) { clearTimeout(mouseoverTimer); mouseoverTimer = undefined; }
      else { urlToPreload = undefined; stopPreloading(); }
    }

    function isPreloadable(a){
      if (!a || !a.href) return false;
      if (urlToPreload == a.href) return false;

      var u = new URL(a.href);
      var sameOrigin = (u.origin === location.origin);
      var isHttp = ['http:', 'https:'].includes(u.protocol);
      var samePage = (u.hash && (u.pathname + u.search) === (location.pathname + location.search));

      if (!isHttp) return false;
      if (!allowExternalLinks && !sameOrigin && !('instant' in a.dataset)) return false;
      if (!allowQueryString && u.search && !('instant' in a.dataset)) return false;
      if (u.protocol === 'http:' && location.protocol === 'https:') return false;
      if (samePage) return false;

      return true;
    }
    function preload(href){ prefetcher.href = href; }
    function stopPreloading(){ prefetcher.removeAttribute('href'); }
  } catch(e) {
    // silent fail — feature is strictly progressive enhancement
  }
})();